import 'jquery-ui-slider/jquery-ui';
import 'jquery-ui-slider-pips-npm/dist/jquery-ui-slider-pips.min.js';
import 'jquery-ui-slider-pips-npm/dist/jquery-ui-slider-pips.min.css';
import 'jquery-ui-touch-punch';

$(function () {
    let $stiffnessComparisonSlider = $('#stiffnessComparisonSlider');

    if ($stiffnessComparisonSlider.length) {
        let $workloadSlider = $stiffnessComparisonSlider.siblings('.workload-slider');

        if ($workloadSlider.length) {
            let obj = $workloadSlider.data('params');
            let params = Object.keys(obj).map(key => obj[key]);

            $workloadSlider.slider({
                min: 0,
                max: params.length - 1,
                range: "min",
            }).slider("pips", {
                rest: "label",
                labels: params,
                suffix: " гр"
            }).on('slidechange slide', function (event, ui) {
                $stiffnessComparisonSlider.find('img.active').toggleClass('active inactive');
                $stiffnessComparisonSlider.find(`img[data-value="${params[ui.value]}"]`).toggleClass('active inactive');
                App.analytics.sendAnalyticsGoal('nagruzka');
            });
        }
    }
});